import React from "react"
import styled from "styled-components"
import Image from "next/image"
import { P } from "@motorata/base-ui.components.atoms.typography"

const EmptyBlock = ({ text }) => {
  return (
    <Wrapper>
      <Image
        priority={true}
        height={35}
        width={200}
        alt="Grafika braku elementów"
        src="/images/empty-box.svg"
      />
      {text && (
        <P small textAlign="center" margin="0">
          {text}
        </P>
      )}
    </Wrapper>
  )
}

export default EmptyBlock

const Wrapper = styled.div<{
  margin?: string
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: ${({ margin }) => margin};

  img {
    width: 40px;
    margin-bottom: 10px;
  }
`
